function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["dictType", "showAll"],
  _excluded2 = ["dictType", "showAll"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Radio as AntRadio } from 'antd';
import { useDict } from "./dict";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DictRadio = function DictRadio(props) {
  var dictType = props.dictType,
    showAll = props.showAll,
    rest = _objectWithoutProperties(props, _excluded);
  var value = rest.value;
  var options = useDict(dictType);

  // if (typeof value === 'number') {
  //   value = String(value);
  // }

  return /*#__PURE__*/_jsxs(AntRadio.Group, _objectSpread(_objectSpread({}, rest), {}, {
    value: value,
    children: [showAll ? /*#__PURE__*/_jsx(AntRadio, {
      value: "",
      children: "\u5168\u90E8"
    }, '') : null, options.map(function (option) {
      return /*#__PURE__*/_jsx(AntRadio, {
        value: option.value,
        children: option.label
      }, option.value);
    })]
  }));
};
export var DictRadioButton = function DictRadioButton(props) {
  var dictType = props.dictType,
    showAll = props.showAll,
    rest = _objectWithoutProperties(props, _excluded2);
  var value = rest.value;
  var options = useDict(dictType);

  // if (typeof value === 'number') {
  //   value = String(value)
  // }

  return /*#__PURE__*/_jsxs(AntRadio.Group, _objectSpread(_objectSpread({}, rest), {}, {
    value: value,
    children: [showAll ? /*#__PURE__*/_jsx(AntRadio.Button, {
      value: "",
      children: "\u5168\u90E8"
    }, '') : null, options.map(function (option) {
      return /*#__PURE__*/_jsx(AntRadio.Button, {
        value: option.value,
        children: option.label
      }, option.value);
    })]
  }));
};
export { AntRadio as Radio };